import { render, staticRenderFns } from "./LanderCta.vue?vue&type=template&id=52376356&scoped=true&"
import script from "./LanderCta.vue?vue&type=script&lang=js&"
export * from "./LanderCta.vue?vue&type=script&lang=js&"
import style0 from "./LanderCta.vue?vue&type=style&index=0&id=52376356&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52376356",
  null
  
)

export default component.exports